
import d3 from 'd3'
import _ from 'underscore'
import Backbone from 'backbone'

class UnitView extends Backbone.View {

  initialize() {
    this.bindEvents()
  }

  bindEvents() {
    this.listenTo(this.model, 'change:fill', this.render)
  }

  unbindEvents() {
    this.stopListening()
  }

  render() {
    let {el, model} = this
    let d3el = d3.select(el)
    let attributes = _.omit(model.get('shape'), 'type')
    attributes.fill = model.get('fill')

    _.each(attributes, function (value, name) {
      d3el.attr(name, value)
    })

    return this
  }
}

export default UnitView
